import { containerTransportOrder } from "./containerTransportOrder";
import { containerTransportContainer } from "./containerTransportContainer";

const consignment = {
	consignor: "Shipper",
	consignee: "Receiver",
	pickedUpRequiredBy: "Required Pickup",
	"consignment.deliveryArea": "Delivery Area",
	"consignment.unpackArea": "Unpack Area",
	"consignment.exportArea": "Export Area",
	"consignment.dropoffArea": "Dropoff Area",
	"consignment.dehireArea": "Dehire Area",
	"consignment.packArea": "Pack Area",
	"consignment.pickupArea": "Pickup Area"
};

const base = {
	projectTitle: "BLL Portal",
	navigation_NewConsignment: "Freight Booking",
	navigation_NewOrder: "Container Booking",
	...consignment,
	...containerTransportOrder,
	...containerTransportContainer
};

export { base };
